import { registerPlugin } from '@capacitor/core';


import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import bgTemple from "../assets/bg-temple.png";
import API from "../api";

import compassIcon from "../assets/icons/compass.png";
import calendarIcon from "../assets/icons/calendar.png";
import messageIcon from "../assets/icons/message.png";
import ouvertureIcon from "../assets/icons/ouverture.png";
import plancheIcon from "../assets/icons/planche.png";
import unionIcon from "../assets/icons/union.png";
import fermetureIcon from "../assets/icons/fermeture.png";

function Home() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const [lastMessages, setLastMessages] = useState([]);
  const [nextEvent, setNextEvent] = useState(null);
  const CallPlugin = registerPlugin('CallPlugin');

  useEffect(() => {
    fetchLastMessages();
    fetchNextEvent();
  }, []);

  const fetchLastMessages = async () => {
    try {
      const res = await API.get("/conversations");
      setLastMessages(res.data.slice(0, 3));
    } catch (err) {
      console.error("Erreur derniers messages:", err);
    }
  };

  const fetchNextEvent = async () => {
    try {
      const res = await API.get("/events");
      if (res.data && res.data.length > 0) {
        setNextEvent(res.data[0]);
      }
    } catch (err) {
      console.error("Erreur prochaine tenue:", err);
    }
  };

  const formatEventDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("fr-FR", {
      weekday: "long",
      day: "numeric",
      month: "long",
    });
  };

  const formatEventTime = (time) => {
    if (!time) return "";
    return time.slice(0, 5);
  };

  const gradeLabel = {
    apprenti: "1er degré",
    compagnon: "2e degré",
    maitre: "3e degré",
  };

  const formatMessageDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const now = new Date();

    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const messageDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

    const diffDays = Math.floor((today - messageDay) / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return date.toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    }

    if (diffDays === 1) return "Hier";

    if (diffDays < 7) {
      return date.toLocaleDateString("fr-FR", {
        weekday: "short",
      });
    }

    return date.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
    });
  };

  const getConversationName = (msg) => {
  if (msg.type === "public") {
    return msg.name || msg.display_name || "Salon de la loge";
  }

  if (msg.type === "group") {
    return msg.name || msg.display_name || "Groupe";
  }

  return (
    msg.display_name ||
    `${msg.firstname || ""} ${msg.lastname || ""}`.trim() ||
    "Conversation"
  );
};

const getAvatarContent = (msg) => {
  if (msg.type === "public") return "🏛️";
  if (msg.type === "group") return "👥";

  return (
    `${msg.firstname?.[0] || ""}${msg.lastname?.[0] || ""}`.toUpperCase() ||
    "?"
  );
};

  const musicItems = [
    { title: "Ouverture", icon: ouvertureIcon },
    { title: "Planche", icon: plancheIcon },
    { title: "Union", icon: unionIcon },
    { title: "Fermeture", icon: fermetureIcon },
  ];

  return (
    <div style={styles.screen}>
      <div style={styles.page}>
        <header style={styles.header}>
          <div>
            <p style={styles.welcome}>Bienvenue</p>
            <h1 style={styles.name}>{user.firstname || "Frère"}</h1>
            <p style={styles.lodge}>Liberté Solidaire</p>
            <div style={styles.goldLine} />
          </div>

          <div style={styles.logoCircle}>
            <img src={compassIcon} alt="Logo" style={styles.logoImg} />
          </div>
        </header>

        <section style={styles.heroCard} onClick={() => navigate("/events")}>
          <div style={styles.heroTop}>
            <div style={styles.bigIconBox}>
              <img src={calendarIcon} alt="" style={styles.bigIcon} />
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={styles.label}>Prochaine tenue</p>

              {nextEvent ? (
                <>
                  <h2 style={styles.heroTitle}>{nextEvent.title}</h2>
                  <p style={styles.degree}>
                    {gradeLabel[nextEvent.grade] || "Tenue"}
                  </p>
                  <p style={styles.infoLine}>
                    📅 {formatEventDate(nextEvent.event_date)}
                  </p>
                  <p style={styles.infoLine}>
                    🕒 {formatEventTime(nextEvent.event_time)}
                  </p>
                  <p style={styles.infoLine}>📍 {nextEvent.location}</p>
                </>
              ) : (
                <>
                  <h2 style={styles.heroTitle}>Aucune tenue prévue</h2>
                  <p style={styles.infoLine}>L’agenda sera bientôt renseigné.</p>
                </>
              )}
            </div>
          </div>

          <button style={styles.primaryBtn}>Voir l’agenda ›</button>
        </section>

        <section style={styles.card} onClick={() => navigate("/messages")}>
          <div style={styles.cardHeader}>
            <div style={styles.titleRow}>
              <img src={messageIcon} alt="" style={styles.sectionIcon} />
              <p style={styles.label}>Derniers messages</p>
            </div>

            <button
              style={styles.textBtn}
              onClick={(e) => {
                e.stopPropagation();
                navigate("/messages");
              }}
            >
              Voir tous ›
            </button>
          </div>

          {lastMessages.length > 0 ? (
            <div style={styles.messagesList}>
              {lastMessages.map((msg) => (
                <div
                  key={msg.id}
                  style={styles.miniMessageRow}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/chat/${msg.id}`);
                  }}
                >
                  <div
                    style={{
                      ...styles.miniAvatar,
                      ...(msg.type === "public"
                        ? styles.publicAvatar
                        : msg.type === "group"
                        ? styles.groupAvatar

                        : styles.privateAvatar),
                    }}
                  >
                    {getAvatarContent(msg)}
                  </div>

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={styles.miniMessageName}>
                      {getConversationName(msg)}
                    </p>

                    <p style={styles.miniMessageText}>
                      {msg.last_message || "Aucun message"}
                    </p>
                  </div>

                  <div style={styles.messageRight}>
                    <p style={styles.time}>
                      {formatMessageDate(msg.last_message_at)}
                    </p>

                    {msg.unread_count > 0 && (
                      <span style={styles.miniBadge}>{msg.unread_count}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p style={styles.emptyText}>Aucun message récent</p>
          )}
        </section>

        <section style={styles.card}>
          <div style={styles.cardHeader}>
            <div style={styles.titleRow}>
              <span style={styles.musicNote}>♪</span>
              <p style={styles.label}>Musique rapide</p>
            </div>

            <button style={styles.textBtn} onClick={() => navigate("/music")}>
              Voir tout ›
            </button>
          </div>

          <div style={styles.musicGrid}>
            {musicItems.map((item) => (
              <button
                key={item.title}
                style={styles.musicCard}
                onClick={() => navigate("/music")}
              >
                <img src={item.icon} alt="" style={styles.musicIcon} />
                <span style={styles.musicText}>{item.title}</span>
              </button>
            ))}
          </div>
        </section>
              

      

      </div>
      </div>
  );
}

const styles = {
  screen: {
    minHeight: "100vh",
    backgroundImage: `
      linear-gradient(rgba(3,6,12,0.62), rgba(3,6,12,0.96)),
      url(${bgTemple})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: "white",
    overflowY: "auto",
    overflowX: "hidden",
  },

  page: {
    minHeight: "100vh",
    boxSizing: "border-box",
    padding: "18px 16px 160px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },

  welcome: {
    margin: 0,
    fontSize: 17,
    fontWeight: 700,
  },

  name: {
    margin: "2px 0 0",
    fontSize: 38,
    lineHeight: 1,
    color: "#d6b46a",
    fontWeight: 900,
  },

  lodge: {
    margin: "4px 0 0",
    fontSize: 18,
    opacity: 0.85,
  },

  goldLine: {
    width: 42,
    height: 4,
    borderRadius: 999,
    background: "#d6b46a",
    marginTop: 10,
  },

  logoCircle: {
    width: 68,
    height: 68,
    borderRadius: "50%",
    border: "2px solid rgba(214,180,106,0.85)",
    background: "rgba(0,0,0,0.35)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 0 30px rgba(214,180,106,0.35)",
    overflow: "hidden",
  },

  logoImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  heroCard: {
    background: "rgba(9,14,22,0.86)",
    border: "1px solid rgba(214,180,106,0.48)",
    borderRadius: 24,
    padding: 14,
    boxShadow: "0 18px 40px rgba(0,0,0,0.42)",
  },

  heroTop: {
    display: "flex",
    gap: 14,
    alignItems: "flex-start",
  },

  bigIconBox: {
    width: 58,
    height: 58,
    borderRadius: 15,
    background: "rgba(255,255,255,0.04)",
    overflow: "hidden",
    flexShrink: 0,
    boxShadow: "0 0 14px rgba(214,180,106,0.18)",
  },

  bigIcon: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  label: {
    margin: 0,
    color: "#d6b46a",
    fontSize: 17,
    fontWeight: 900,
  },

  heroTitle: {
    margin: "6px 0 5px",
    fontSize: 25,
    lineHeight: 1.05,
    fontWeight: 900,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  degree: {
    display: "inline-block",
    margin: "0 0 5px",
    padding: "4px 9px",
    borderRadius: 999,
    background: "rgba(214,180,106,0.16)",
    border: "1px solid rgba(214,180,106,0.35)",
    color: "#f4d98d",
    fontSize: 12,
    fontWeight: 900,
  },

  infoLine: {
    margin: "3px 0",
    fontSize: 15,
    opacity: 0.86,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  primaryBtn: {
    width: "100%",
    marginTop: 12,
    padding: "12px 16px",
    border: "none",
    borderRadius: 14,
    background: "linear-gradient(180deg, #e4c46f, #c99f43)",
    color: "#101010",
    fontSize: 16,
    fontWeight: 900,
    cursor: "pointer",
  },

  card: {
    background: "rgba(9,14,22,0.86)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 22,
    padding: 13,
    boxShadow: "0 16px 34px rgba(0,0,0,0.35)",
  },

  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },

  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },

  sectionIcon: {
    width: 34,
    height: 34,
    objectFit: "contain",
    filter: "drop-shadow(0 0 8px rgba(214,180,106,0.35))",
  },

  textBtn: {
    border: "none",
    background: "transparent",
    color: "#d6b46a",
    fontSize: 16,
    fontWeight: 800,
    cursor: "pointer",
  },

  messagesList: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },

  miniMessageRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    cursor: "pointer",
  },

  miniAvatar: {
    width: 38,
    height: 38,
    borderRadius: "50%",
    color: "#111",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 15,
    fontWeight: 900,
    flexShrink: 0,
  },

  privateAvatar: {
    background: "linear-gradient(180deg, #e4c46f, #c99f43)",
  },

  groupAvatar: {
    background: "linear-gradient(180deg, #d8d8d8, #8f949b)",
    color: "#111",
  },

  publicAvatar: {
  background: "linear-gradient(180deg, #e4c46f, #c99f43)",
  color: "#111",
  boxShadow: "0 0 14px rgba(214,180,106,0.45)",
},

  miniMessageName: {
    margin: 0,
    fontSize: 15,
    fontWeight: 900,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  miniMessageText: {
    margin: "2px 0 0",
    fontSize: 13,
    opacity: 0.75,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  messageRight: {
    minWidth: 42,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: 5,
  },

  time: {
    margin: 0,
    fontSize: 12,
    opacity: 0.7,
    whiteSpace: "nowrap",
  },

  miniBadge: {
    minWidth: 21,
    height: 21,
    borderRadius: 999,
    background: "#d6b46a",
    color: "#111",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 900,
  },

  emptyText: {
    margin: 0,
    opacity: 0.7,
  },

  musicNote: {
    color: "#d6b46a",
    fontSize: 28,
    fontWeight: 900,
    lineHeight: 1,
  },

  musicGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: 6,
  },

  musicCard: {
    height: 86,
    borderRadius: 18,
    background: "transparent",
    border: "none",
    color: "white",
    padding: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    cursor: "pointer",
    overflow: "visible",
  },

  musicIcon: {
    width: 52,
    height: 52,
    objectFit: "contain",
    filter: "drop-shadow(0 0 8px rgba(214,180,106,0.35))",
  },

  musicText: {
    fontSize: 12,
    fontWeight: 900,
    lineHeight: 1,
    color: "white",
    textShadow: "0 2px 6px rgba(0,0,0,0.9)",
  },
};

export default Home;